import { render, staticRenderFns } from "./InputDateMedicare.vue?vue&type=template&id=0dfb9196&scoped=true"
import script from "./InputDateMedicare.vue?vue&type=script&lang=js"
export * from "./InputDateMedicare.vue?vue&type=script&lang=js"
import style0 from "./InputDateMedicare.vue?vue&type=style&index=0&id=0dfb9196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfb9196",
  null
  
)

export default component.exports